export default __webpack_public_path__ + "static/media/lined.1645fd23.png";